import React, { useState } from 'react'
import bracketsCurly from '../../../img/brackets-curly-solid.svg'
import rectangleXmark from '../../../img/rectangle-xmark.svg'
import styles from './styles.module.css'
import { CircularProgress } from '@material-ui/core'

function HeaderExpandedRecord ({ record, handleClose, toggleJsonModal }) {
  const [loading, setLoading] = useState(true)

  const handleImageLoad = () => {
    setLoading(false)
  }

  const handleImageError = () => {
    setLoading(false)
  }

  return (
    <section className={styles.headerExpandedRecordContainerHeader}>
      <div className={styles.headerExpandedRecordImageAndNameContainer}>
        <div className={styles.headerExpandedRecordImageContainer}>
          {loading && (
            <div className={styles.headerExpandedRecordLoadingOverlay}>
              <CircularProgress
                disableShrink
                size={30}
                style={{ color: '#065E88' }}
              />
            </div>
          )}
          <img
            src={
              record?.imageURLs && record.imageURLs.length > 0
                ? record.imageURLs[0]
                : require('../../../img/noValidImageFound.jpeg')
            }
            alt='ProductImage'
            onLoad={handleImageLoad}
            onError={handleImageError}
            className={`${styles.headerExpandedRecordProductImage} ${
              loading ? styles.headerExpandedRecordHidden : ''
            }`}
          />
        </div>
        <div className={styles.headerExpandedRecordProductDetails}>
          <div className={styles.headerExpandedRecordName}>
            <h1 className={styles.headerExpandedRecordProductName}>
              {record?.name || 'N/A'}
            </h1>
          </div>
          {/*  */}
          <div className={styles.headerExpandedRecordAttributes}>
            <div className={styles.headerExpandedRecordAttributeColumn}>
              <label className={styles.headerExpandedRecordLabel} htmlFor=''>
                Most recent price
              </label>
              <span className={styles.headerExpandedRecordValue}>
                {record.mostRecentPriceAmount
                  ? `$${record.mostRecentPriceAmount.toLocaleString('en-US')}`
                  : 'N/A'}
              </span>
            </div>
          </div>
          {/*  */}
          {/*  */}
          <div className={styles.headerExpandedRecordAttributes}>
            <div className={styles.headerExpandedRecordAttributeColumn}>
              <label className={styles.headerExpandedRecordLabel} htmlFor=''>
                Brand
              </label>
              <span className={styles.headerExpandedRecordValue}>
                {record?.brand || 'N/A'}
              </span>
            </div>
            <div className={styles.headerExpandedRecordAttributeColumn}>
              <label className={styles.headerExpandedRecordLabel} htmlFor=''>
                Manufacturer
              </label>
              <span className={styles.headerExpandedRecordValue}>
                {record?.manufacturer || 'N/A'}
              </span>
            </div>
          </div>
          {/*  */}

          {/*  */}
          <div className={styles.headerExpandedRecordAttributes}>
            <div className={styles.headerExpandedRecordAttributeColumn}>
              <label className={styles.headerExpandedRecordLabel} htmlFor=''>
                Manufacturer #
              </label>
              <span className={styles.headerExpandedRecordValue}>
                {record?.manufacturerNumber || 'N/A'}
              </span>
            </div>
            <div className={styles.headerExpandedRecordAttributeColumn}>
              <label className={styles.headerExpandedRecordLabel} htmlFor=''>
                UPC/GTIN
              </label>
              <span className={styles.headerExpandedRecordValue}>
                {record?.gtins && record.gtins.length > 0
                  ? record.gtins[0]
                  : 'N/A'}
              </span>
            </div>
          </div>
          {/*  */}
        </div>
      </div>
      <div className={styles.headerExpandedRecordActions}>
        <div
          className={styles.headerExpandedRecordCloseIconContainer}
          onClick={handleClose}
        >
          <span className={styles.headerExpandedRecordButtonClose}>Close</span>
          <img
            alt='rectangleXmarkIcon'
            src={rectangleXmark}
            className={styles.headerExpandedRecordRectangleIcon}
          />
        </div>
        <div
          className={styles.headerExpandedRecordViewJson}
          onClick={toggleJsonModal}
        >
          <span className={styles.headerExpandedRecordButton}>View JSON</span>
          <img
            alt='bracketsCurly'
            src={bracketsCurly}
            className={styles.headerExpandedRecordBracketsIcon}
          />
        </div>
      </div>
    </section>
  )
}

export default HeaderExpandedRecord
